var __webpack_exports__ = {};
/*!********************************!*\
  !*** ./src/js/filter-price.js ***!
  \********************************/
var initprice = function initprice() {
  var inputs = document.querySelectorAll(".range-input");
  inputs.forEach(function (input) {
    setBackgroundSize(input);
    input.addEventListener("input", function () {
      return setBackgroundSize(input);
    });
  });
};
function setBackgroundSize(input) {
  input.style.setProperty("--background-size", "".concat(getBackgroundSize(input), "%"));
}
function getBackgroundSize(input) {
  var min = +input.min || 0;
  var max = +input.max || 100;
  var value = +input.value;
  var size = (value - min) / (max - min) * 100;
  return size;
}
window.addEventListener('load', initprice);
